module.exports = __webpack_public_path__ + "static/media/shop03.1135c091.png";